import React, { useCallback } from "react";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";

import { Grid } from "@material-ui/core";
import * as Yup from "yup";

import { ReportJobAction } from "actions/reportJob";
import {
  getEndDateValidation,
  getStartDateValidation,
} from "components/MultiSaleReports/commonValidation";
import {
  BulkReportFormProps,
  ModalActions,
} from "components/MultiSaleReports/ManyReportsForm/BulkReportFormCommon";
import { FinancialStatementForm, FinancialStatementFormValues } from "./Form";

export const validationSchema = Yup.object().shape({
  startDate: getStartDateValidation("endDate", { isYearOptionAllowed: true }),
  endDate: getEndDateValidation(),
});

type SupportedReportType =
  | "FinancialStatementReport"
  | "FinancialStatementZipReport";

type FormValueType = {
  report: SupportedReportType;
} & FinancialStatementFormValues;

interface FormProps extends BulkReportFormProps {
  reportSlug: SupportedReportType;
}

export function CreateFinancialStatementReportJobsForm(
  props: FormProps,
): React.JSX.Element {
  const { reportSlug, onClose } = props;

  const dispatch = useDispatch();

  const onSubmit = useCallback(
    (values: FormValueType) => {
      dispatch(ReportJobAction.createBulk(values));
      onClose();
    },
    [dispatch, onClose],
  );

  const initialValues: FormValueType = {
    report: reportSlug,
    startDate: null,
    endDate: null,
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <Form>
        <Grid container spacing={2}>
          <FinancialStatementForm namespace="" />
        </Grid>
        <ModalActions onClose={onClose} />
      </Form>
    </Formik>
  );
}
